import api from "app/api";

export enum ActivationType {
  PASSWORD = 'PASSWORD',
  EMAIL = 'EMAIL',
  REGISTRATION = 'REGISTRATION',
  INTEGRATION = 'INTEGRATION',
  INVITATION = 'INVITATION',
}

export function validateToken(token: string, type: ActivationType) {
  return api.get(`/activation/validate?token=${token}&type=${type.toUpperCase()}`);
}

export function resendToken(email: string, type: ActivationType) {
  return api.post(`/activation/resend`, {
    ResendActivationForm: {
      email,
      type,
    }
  });
}

export function getTokenData(token: string, type: ActivationType) {
  return api.get(`/activation/data?token=${token}&type=${type.toUpperCase()}`);
}